import React from "react";
import { Button } from "antd";

/**
 * Friendly empty state — simple hand-written line-art SVG + message +
 * optional action button. Pass via Table's locale={{ emptyText: <EmptyState/> }}.
 */
const EmptyState = ({ message = "No data yet", actionLabel, onAction }) => (
  <div className="i-ems-empty-state">
    <svg width="96" height="72" viewBox="0 0 96 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="14" y="14" width="68" height="48" rx="8" stroke="var(--i-ems-border)" strokeWidth="2" fill="var(--i-ems-primary-light)" />
      <line x1="24" y1="28" x2="60" y2="28" stroke="var(--i-ems-border)" strokeWidth="2" strokeLinecap="round" />
      <line x1="24" y1="38" x2="72" y2="38" stroke="var(--i-ems-border)" strokeWidth="2" strokeLinecap="round" />
      <line x1="24" y1="48" x2="50" y2="48" stroke="var(--i-ems-border)" strokeWidth="2" strokeLinecap="round" />
      <circle cx="72" cy="52" r="14" fill="var(--i-ems-surface)" stroke="var(--i-ems-accent)" strokeWidth="2" />
      <path d="M67 52l3.5 3.5L78 48" stroke="var(--i-ems-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
    <div className="i-ems-empty-state-message">{message}</div>
    {actionLabel ? (
      <Button type="primary" size="small" onClick={onAction}>
        {actionLabel}
      </Button>
    ) : null}
  </div>
);

export default EmptyState;
